import apiClient from "./index";
/** 게시판 내용 API */

// 게시판 내용 목록 조회
export const findAll = search => {
    return apiClient.post(`/sys/bbsCn/findAll.json`, search);
}
// 게시판 내용 상세 조회
export const findByBbsCn = bbsCn => {
    return apiClient.post(`/sys/bbsCn/findByBbsCn.json`, bbsCn);
}
// 게시판 내용 등록
export const save = bbsCn => {
    return apiClient.post(`/sys/bbsCn/saveProc.json`, bbsCn);
}
// 게시판 내용 수정
export const update = bbsCn => {
    return apiClient.post(`/sys/bbsCn/updateProc.json`, bbsCn);
}
// 게시판 내용 삭제
export const del = bbsCn => {
    return apiClient.post(`/sys/bbsCn/deleteProc.json`, bbsCn);
}
// 게시판 조회수 증가
export const updateVwCnt = params => {
    return apiClient.post(`/sys/bbsCn/updateVwCnt.json`, params);
}
/***** 질의형 *****/
// 게시판 답변 등록
export const fnqSave = bbsCn => {
    return apiClient.post(`/sys/bbsCn/ansSaveProc.json`, bbsCn);
}
// 게시판 답변 수정
export const fnqUpdate = bbsCn => {
    return apiClient.post(`/sys/bbsCn/ansUpdateProc.json`, bbsCn);
}
// 게시판 답변 삭제
export const fnqdelete = bbsCn => {
    return apiClient.post(`/sys/bbsCn/ansDeleteProc.json`, bbsCn);
}

// 공무원 메인페이지 > 공지사항 최신 5개 조회
export const findFiveNotice = params => {
    return apiClient.post(`/sys/bbsCn/findFiveNotice.json`, params);
}